import { match } from 'ts-pattern'
import { CarouselBase } from '@/components/common/carousels/CarouselBase'
import { Image } from '@/components/common/images/Image'
import ProductDetailTimeSale from '@/components/domains/product-detail/ProductDetailTimeSale'
import { BannerState } from '@/components/domains/product-detail/product-detail.type'
import { getImageUrl } from '@/utils/utilURL'
import styles from './ProductDetailMainImageBanner.module.css'

interface ProductDetailMainImageBannerProps {
  images: string[]
  sticker?: string
  name: string
  endedAt: string
  isTimeSale: boolean
  isRealSoldOut: boolean
  isNotAvailable: boolean
}

export const ProductDetailMainImageBanner = ({
  images,
  sticker,
  name,
  endedAt,
  isTimeSale,
  isRealSoldOut,
  isNotAvailable,
}: ProductDetailMainImageBannerProps) => {
  const isBannerState = isTimeSale ? BannerState.timeSale : isRealSoldOut ? BannerState.isSoldOut : undefined
  const stickerUrl = getImageUrl(sticker)

  return (
    <>
      <CarouselBase arrowTopPosition={220} dots>
        {images.map((image, index) => (
          <div className={styles.imageWrapper} key={index}>
            {stickerUrl !== undefined && index === 0 ? (
              <ImageWithSticker image={image} stickerUrl={stickerUrl} name={name} index={index} />
            ) : (
              <Image src={image} alt={`${name} ${index + 1}번째 이미지`} aspectRatio="1/1" objectFit="cover" />
            )}
          </div>
        ))}
      </CarouselBase>
      {!isNotAvailable && isBannerState && (
        <div className={styles.footer}>
          {match(isBannerState)
            .with(BannerState.timeSale, () => <ProductDetailTimeSale endedAt={endedAt} />)
            .with(BannerState.isSoldOut, () => (
              <span className="font-body1-semibold gray-white">재입고 예정이니 조금만 기다려주세요</span>
            ))
            .exhaustive()}
        </div>
      )}
    </>
  )
}

interface CarouselProductImageWithStickerProps {
  image: string
  stickerUrl: string
  name: string
  index: number
}

const ImageWithSticker = ({ image, stickerUrl, name, index }: CarouselProductImageWithStickerProps) => {
  return (
    <div className={styles.imageWithStickerWrapper}>
      <Image src={image} alt={`${name} ${index + 1}번째 이미지`} aspectRatio="1/1" objectFit="cover" />
      <div className={styles.stickerWrapper}>
        <Image src={stickerUrl} alt="sticker" />
      </div>
    </div>
  )
}
